import styled from "styled-components";
export const Area = styled.div<{$width?: number, $height?: number}>`
    background-color: ${({theme}) => theme.color.primary_100};
    border-radius: 8px;
    width: ${(props) => props.$width || 100}px;
    height: ${(props) => props.$height || 100}px;
    border: 1px solid ${({theme}) => theme.color.primary_300};
    box-shadow: ${({theme}) => theme.name === 'dark'
        ? '0 1px 2px rgba(0, 0, 0, 0.22)'
        : '0 1px 2px rgba(16, 24, 40, 0.04)'};
`;

/** Business surface without the login Area's fixed dimensions. */
export const Surface = styled.section`
    width: 100%; height: auto; min-width: 0;
    background: ${({ theme }) => theme.color.primary_100};
    color: ${({ theme }) => theme.color.text_color_100};
    border: 1px solid ${({ theme }) => theme.color.primary_300};
    border-radius: 8px;
`;
